import { noOp } from 'common/Constants';

export const defaultState = {
  navigation: {
    isOpen: false,
    open: noOp,
    close: noOp,
    toggle: noOp,
  },
};
